export default "__VITE_ASSET__DWqJ3M5p__"